var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIconError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OTL/Circle/alert"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 8C14 4.6875 11.3125 2 8 2C4.6875 2 2 4.6875 2 8C2 11.3125 4.6875 14 8 14C11.3125 14 14 11.3125 14 8Z",
    stroke: "#FD605D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.8205 5.18946L7.99987 9.0004L8.17893 5.18946C8.18004 5.1651 8.17617 5.14077 8.16755 5.11795C8.15893 5.09514 8.14576 5.07432 8.12882 5.05677C8.11189 5.03922 8.09155 5.02531 8.06906 5.01589C8.04656 5.00646 8.02238 5.00172 7.998 5.00196V5.00196C7.9739 5.00219 7.9501 5.00727 7.92801 5.0169C7.90591 5.02653 7.88599 5.04051 7.86942 5.05801C7.85286 5.07551 7.83999 5.09617 7.83158 5.11876C7.82317 5.14134 7.8194 5.16539 7.8205 5.18946V5.18946Z",
    stroke: "#FD605D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8 11.4971C7.87639 11.4971 7.75555 11.4604 7.65277 11.3917C7.54999 11.3231 7.46988 11.2255 7.42258 11.1112C7.37527 10.997 7.36289 10.8714 7.38701 10.7501C7.41113 10.6289 7.47065 10.5175 7.55806 10.4301C7.64547 10.3427 7.75683 10.2832 7.87807 10.2591C7.99931 10.235 8.12497 10.2473 8.23918 10.2946C8.35338 10.342 8.45099 10.4221 8.51967 10.5248C8.58834 10.6276 8.625 10.7485 8.625 10.8721C8.625 11.0378 8.55915 11.1968 8.44194 11.314C8.32473 11.4312 8.16576 11.4971 8 11.4971Z",
    fill: "#FD605D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIconError);
export default __webpack_public_path__ + "static/media/alert-icon-error.3035c11189f54457bda7d9990fb1ca22.svg";
export { ForwardRef as ReactComponent };